import { useEffect, useRef, useState } from "react";
import env from "shared/config/env";
import io from "socket.io-client";

const useDominoSocket = (inputCode, userName) => {
    const [isJoined, setIsJoined] = useState(false);
    const [players, setPlayers] = useState([]);
    const [gameStarted, setGameStarted] = useState(false);
    const [myHand, setMyHand] = useState([]);
    const [myPlayerNum, setMyPlayerNum] = useState(null);
    const [gs, setGs] = useState(null);
    const socketRef = useRef(null);

    useEffect(() => {
        return () => socketRef.current?.disconnect();
    }, []);

    const joinRoom = () => {
        if (!inputCode) return;

        socketRef.current = io(env.baseUrl, {
            transports: ["websocket"],
            withCredentials: true,
        });

        socketRef.current.emit("join_room", {
            roomCode: inputCode,
            password: inputCode,
            playerName: userName,
        });

        socketRef.current.on("update_player_list", setPlayers);

        socketRef.current.on("domino_game_started", ({ playerOrder, numPlayers, targetScore, myHand: hand, handCounts, boneyardCount, cur, scores }) => {
            const myIdx = playerOrder.indexOf(socketRef.current.id);
            setMyPlayerNum(myIdx >= 0 ? myIdx + 1 : 0);
            setMyHand(hand);
            setGs({ chain: [], leftEnd: null, rightEnd: null, cur, handCounts, boneyardCount, scores, numPlayers, targetScore, roundOver: false, gameOver: false, blocked: false, msg: "" });
            setGameStarted(true);
        });

        socketRef.current.on("domino_state_update", (data) => {
            setGs((prev) => ({ ...prev, ...data }));
        });

        socketRef.current.on("domino_hand_update", ({ myHand: hand }) => {
            setMyHand(hand);
        });

        socketRef.current.on("domino_back_to_lobby", () => {
            setGameStarted(false);
            setGs(null);
            setMyHand([]);
            setMyPlayerNum(null);
        });

        socketRef.current.on("force_leave_room", () => {
            exitRoom();
            alert("ห้องถูกรีเซ็ตแล้ว");
        });

        setIsJoined(true);
    };

    const startGame = (numPlayers, targetScore) => {
        socketRef.current?.emit("domino_start_game", { roomCode: inputCode, numPlayers, targetScore });
    };

    const placeTile = (tileId, end) => {
        socketRef.current?.emit("domino_place_tile", { roomCode: inputCode, tileId, end });
    };

    const drawBoneyard = () => {
        socketRef.current?.emit("domino_draw_boneyard", { roomCode: inputCode });
    };

    const passTurn = () => {
        socketRef.current?.emit("domino_pass_turn", { roomCode: inputCode });
    };

    const nextRound = () => {
        socketRef.current?.emit("domino_next_round", { roomCode: inputCode });
    };

    const backToLobby = () => {
        socketRef.current?.emit("domino_back_to_lobby", { roomCode: inputCode });
    };

    const exitRoom = () => {
        socketRef.current?.disconnect();
        setIsJoined(false);
        setPlayers([]);
        setGameStarted(false);
        setGs(null);
        setMyHand([]);
        setMyPlayerNum(null);
    };

    return {
        isJoined, players, gameStarted, myHand, myPlayerNum, gs,
        socketRef, joinRoom, startGame, placeTile, drawBoneyard, passTurn, nextRound, backToLobby, exitRoom,
    };
};

export default useDominoSocket;
